import React from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';
import { Box, Grid } from '@mui/material';
import RecipesEndUserMealItem from './recipes_end_user_meal_item';
import RecipePlaceholderCard from '../meal/recipe_placeholder_card';

const RecipesEndUserAppHomePageSection = ({
  title,
  entries,
  viewAllLink,
  isLoading,
}) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    fallbackInView: true,
  });

  // console.log(JSON.stringify(entries, null, 2));
  if (inView) {
    console.log(
      `RecipesEndUserAppHomePageSection is in view: ${title} - ${entries.length} entries`,
    );
  }
  return (
    <div ref={ref} style={{ minHeight: '332.5px' }}>
      {inView && (
        <>
          <Grid container>
            <Grid item xs={8}>
              <h2
                style={{
                  margin: '23px 23px 5px',
                  color: 'var(--app-primary-font-color)',
                  textAlign: 'left',
                }}>
                {title}
              </h2>
            </Grid>
            <Grid
              item
              xs={4}
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
              }}>
              <Box
                sx={{
                  margin: 'auto 10px 7px',
                  color: 'var(--app-primary-font-color)',
                }}>
                <Link to={viewAllLink}>View all</Link>
              </Box>
            </Grid>
          </Grid>

          {isLoading && <RecipePlaceholderCard />}

          <div style={{ overflowX: 'auto', display: 'flex' }}>
            {entries.map(({ mealID, menuID, parentID, isDeleteEnabled }) => (
              <div key={mealID} style={{ flexShrink: 0 }}>
                <RecipesEndUserMealItem
                  mealID={mealID}
                  menuID={menuID}
                  parentID={parentID}
                  deleteEnabled={isDeleteEnabled}
                  favouriteEnabled
                />
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

RecipesEndUserAppHomePageSection.propTypes = {
  title: PropTypes.string.isRequired,
  entries: PropTypes.arrayOf(
    PropTypes.shape({
      mealID: PropTypes.string.isRequired,
      menuID: PropTypes.string.isRequired,
      parentID: PropTypes.string.isRequired,
    }),
  ).isRequired,
  viewAllLink: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default RecipesEndUserAppHomePageSection;
